import { FormLabel, Typography } from '@mui/material'
import colors from '../../constants/colors'
import { ILabelErrorTAG } from './types'

const LabelErrorTAG: React.FC<ILabelErrorTAG> = ({ error, label, mandatory = false }) => {
  return (
    <FormLabel
      sx={{ typography: 'labelBold', marginBottom: '.7rem', color: colors.BLACK }}
      error={!!error}
    >
      {label}
      {mandatory && (
        <span style={{ marginLeft: '.4rem' }} className='t-color-red'>
          *
        </span>
      )}
      {error && (
        <Typography sx={{ fontSize: 12, paddingLeft: '.8rem' }} display='inline'>
          ({error})
        </Typography>
      )}
    </FormLabel>
  )
}

export default LabelErrorTAG
